import { render } from "./TermsView.vue?vue&type=template&id=7b4dbf70&scoped=true"
import script from "./TermsView.vue?vue&type=script&lang=js"
export * from "./TermsView.vue?vue&type=script&lang=js"

import "./TermsView.vue?vue&type=style&index=0&id=7b4dbf70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4dbf70"]])

export default __exports__